export interface TenantConfig {
    id: string;
    name: string;
    domain: string;
    apiSuffix: string;
    features: {
        showAcessoRapido: boolean;
        showServices: boolean;
    };
}

export const TENANTS: Record<string, TenantConfig> = {
    'itajai.sc.gov.br': {
        id: 'municipio',
        name: 'Portal do Município',
        domain: 'itajai.sc.gov.br',
        apiSuffix: 'portaladm-pmitajai',
        features: {
            showAcessoRapido: true,
            showServices: true,
        },
    },
    'saude.itajai.sc.gov.br': {
        id: 'saude',
        name: 'Portal da Saúde',
        domain: 'saude.itajai.sc.gov.br',
        apiSuffix: 'portaladm-saude',
        features: {
            showAcessoRapido: true,
            showServices: false,
        },
    },
    'educacao.itajai.sc.gov.br': {
        id: 'educacao',
        name: 'Portal da Educação',
        domain: 'educacao.itajai.sc.gov.br',
        apiSuffix: 'portaladm-educacao',
        features: {
            showAcessoRapido: false,
            showServices: false,
        },
    },
    'fmel.itajai.sc.gov.br': {
        id: 'fmel',
        name: 'FMEL',
        domain: 'fmel.itajai.sc.gov.br',
        apiSuffix: 'portaladm-fmel',
        features: {
            showAcessoRapido: true,
            showServices: false,
        },
    },
};

export const DEFAULT_TENANT = TENANTS['itajai.sc.gov.br'];

